<template>
  <div class="dk-folders-root">

    <!-- ── Breadcrumb ── -->
    <div v-if="paths.length > 0" class="dk-breadcrumb">
      <span
        v-for="(path, idx) in paths"
        :key="idx"
        class="dk-breadcrumb__item"
      >
        <span v-if="idx > 0" class="dk-breadcrumb__sep" />
        <a
          :class="['dk-breadcrumb__link', idx === paths.length - 1 ? 'dk-breadcrumb__link--active' : '']"
          @click="backToFolder(path)"
        >
          <feather-icon v-if="idx === 0" icon="VideoIcon" size="12" class="dk-breadcrumb__icon" />
          <feather-icon v-else-if="idx === paths.length - 1" icon="FolderIcon" size="12" class="dk-breadcrumb__icon" />
          {{ path.folder_name }}
        </a>
      </span>
    </div>

    <!-- ── Page header row ── -->
    <div class="dk-folders-header">
      <div class="dk-folders-header__left">
        <feather-icon icon="FolderIcon" size="18" class="dk-folders-header__icon" />
        <span class="dk-folders-header__title">Pastas</span>
        <span v-if="folders.length" class="dk-folders-header__count">{{ folders.length }}</span>
      </div>
      <b-button
        id="toggle-btn"
        v-ripple.400="'rgba(232,106,16,0.15)'"
        v-b-modal.modal-prevent-closing
        variant="primary"
        size="sm"
        class="dk-new-folder-btn"
        @click="idfolderAtual()"
      >
        <feather-icon icon="FolderPlusIcon" size="14" class="mr-50" />
        Nova Pasta
      </b-button>
    </div>

    <!-- ── Modal criar pasta ── -->
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Nova pasta"
      ok-title="Criar Pasta"
      cancel-title="Cancelar"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="CriarPasta">
        <b-form-group
          :state="nameState"
          label="Nome da pasta"
          label-for="name-input"
          invalid-feedback="Esse campo é obrigatório"
        >
          <b-form-input
            id="name-input"
            v-model="pastaAws.folder_name"
            :state="nameState"
            placeholder="Digite o nome da pasta"
            required
          />
        </b-form-group>
      </form>
    </b-modal>

    <!-- ── Grid de pastas ── -->
    <div class="dk-folder-grid">
      <div
        v-for="item of folders"
        :key="item.id"
        class="dk-folder-card"
        @click="getFolder(item)"
      >
        <!-- Header com ações -->
        <div class="dk-folder-card__top">
          <div class="dk-folder-card__icon">
            <folder />
          </div>
          <div class="dk-folder-card__actions" @click.stop>
            <span
              :id="'icone-editar' + item.id"
              class="dk-folder-card__edit-btn"
              @click.stop="aparecerEdição(item.id)"
            >
              <feather-icon icon="Edit3Icon" size="13" />
            </span>
            <span
              :id="'botao-salvar' + item.id"
              class="dk-folder-card__save-btn"
              hidden
              @click.stop="salvarEdicão(item)"
            >
              <feather-icon icon="CheckIcon" size="13" />
            </span>
            <el-dropdown>
              <button class="dk-folder-card__more-btn">
                <feather-icon icon="MoreHorizontalIcon" size="15" />
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="open(item)">
                  <div class="dk-dropdown-item dk-dropdown-item--danger">
                    <feather-icon icon="TrashIcon" size="14" class="mr-50" />
                    <span>Remover pasta</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>

        <!-- Info -->
        <div class="dk-folder-card__body">
          <strong :id="'strong' + item.id" class="dk-folder-card__name">{{ item.folder_name }}</strong>
          <input
            :id="'input' + item.id"
            v-model="item.folder_name"
            class="dk-folder-card__name-input"
            hidden
            @click.stop
          />
          <div class="dk-folder-card__date">
            <feather-icon icon="CalendarIcon" size="11" />
            {{ item.folder_date }}
          </div>
        </div>
      </div>

      <!-- Empty state: só na raiz sem pastas -->
      <div v-if="folders.length === 0 && paths.length === 0" class="dk-folders-empty">
        <feather-icon icon="FolderIcon" size="40" class="dk-folders-empty__icon" />
        <p class="dk-folders-empty__text">Nenhuma pasta criada ainda</p>
        <p class="dk-folders-empty__sub">Clique em "Nova Pasta" para organizar seus vídeos</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { useApi } from '@/composables/useApi'
// eslint-disable-next-line import/extensions
import { FolderService } from '@/services/Folder.js'
import { mapActions, mapState } from 'vuex'
// const apiAWS = useApiAWS()
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BCardText, BListGroup, BListGroupItem, BAlert, BLink, BCard,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import { codePrevent } from '@/views/App/Pastas/code copy'
import Folder from '@/assets/images/folder/folder.vue'
import crypto from 'crypto'

const api = useApi()

export default {
  components: {
    BCardCode,
    BButton,
    BFormGroup,
    BCardText,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BAlert,
    BLink,
    BCard,
    Folder,
  },
  props: ['value'],
  computed: {
    ...mapState('Folders', ['folderAtual']),
    folders: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  name: 'Modal',
  directives: {
    'b-modal': VBModal,

    Ripple,
  },
  data() {
    return {
      input: '',
      loading: false,
      paths: [],
      outerVisible: false,
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3 || '/api/dkbucket',
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      userData: JSON.parse(localStorage.getItem('userData')),
      errorMessage: null,
      codePrevent,
      pastaAws: {
        folder_name: '',
      },
      nameState: null,
      checkFile: false,
      IdPasta: '',
      folderATUAL: {},
    }
  },

  methods: {
    ...mapActions('Folders', ['getAllFolderUser', 'getAllMoverFolder']),
    handleChecked(item) {
      this.$emit('selectVideoFolder', item)
    },

    async getFolder(item) {
      this.loading = true
      this.$store.commit('Folders/setCurrentFolderId', item.id)
      this.$store.commit('Folders/setfolderAtual', item)

      localStorage.setItem('folderATUAL', JSON.stringify(item))
      this.$emit('updateVideos', item)
      this.getAllFolderUser()
      this.getFoldersAll(item.id)
      this.IdPasta = item
      if (this.paths.length === 0) {
        this.paths.push({
          folder_name: 'Meus Videos',
          icon: 'fi fi-bs-video-camera',
          id: 0,
        })
      }
      const res = this.paths.find(f => f.id === item.id)
      if (res === undefined) {
        this.paths.push(item)
      }

      this.$store.commit('Folders/setIdMainParams', item.id)
      await this.$store.dispatch('Folders/getAllFolderUser')
        .finally(() => {
          this.loading = false
        })
    },

    async getFoldersAll(id_folder) {
      const params = {
        id_main: id_folder,
      }
      await api.get(`/folderUser/${this.getUserData.id}`, {
        params,
      })
        .then(resp => {
          const formData = resp.data
          formData.map(v => v.is_selected = false)
          this.folders = formData
        })
    },

    deleteFolder(folder) {
      try {
        this.loading = true
        FolderService.deleteFolder(folder.id).then(response => {
          if (response) {
            this.getFoldersAll(folder.id_main)
            // if (typeof this.folderATUAL.id === "undefined") {

            //   this.getFoldersAll(0)
            // } else {
            //   this.getFoldersAll(this.folderATUAL.id)
            // }
            // ;
          }
        })
      } catch (error) {
        this.errorMessage = error
        this.loading = false
      }
    },

    deletarPastaAWS(item) {
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}`,
        params: {
          key: item,
          delete: '',
        },
      }

      axios.request(options).then(response => {
      }).catch(error => {
        console.error(error)
      })
    },

    open(item) {
      //  this.folderATUAL = item;
      this.$confirm('Você tem certeza que deseja deletar a pasta? Se sim, todos os dados e arquivos serão removidos.', 'Deletar Pasta', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'Deletar pasta',
      }).then(res => {
        if (res) {
          this.deletarPastaAWS(item.folder_key_name)
          this.deleteFolder(item)
        }

        this.$message({
          type: 'success',
          message: 'Deletado com sucesso',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelado',
        })
      })
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.name = valid
      return valid
    },
    resetModal() {
      this.pastaAws.folder_name = ''
      this.nameState = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.CriarPasta()
    },
    async idfolderAtual() {
      const pastaAtual = JSON.parse(localStorage.getItem('folderATUAL'))
      this.folderATUAL = pastaAtual
    },
    handleSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/folder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"folder_name":"${this.pastaAws.folder_name.replace(/(\r\n|\n|\r)/gm, '')
        }","folder_backet_adress":"${this.Url_pasta
        }","id_main":"${this.folderATUAL && this.folderATUAL.id != null ? this.folderATUAL.id : 0
        }","folder_key_name":"${this.key_name
        }","id_user":"${this.userData.id}"}`,
      })
        .then(async response => {
          const mainId = (this.folderATUAL && this.folderATUAL.id != null) ? this.folderATUAL.id : 0
          this.getFoldersAll(mainId)
          await this.getAllMoverFolder({ id_main: mainId }).then(res => {
            this.folders = res
          })

          await this.$store.dispatch('Folders/getAllFolderUser')
            .finally(() => {
              this.loading = false
            })
          this.$notify({
            title: 'Success',
            message: 'Pasta criada com sucesso.',
            type: 'success',
          })
        })
        .catch(err => console.error(err))

      this.$nextTick(() => {
        if (this.$refs['my-modal']) {
          this.$refs['my-modal'].toggle('#toggle-btn')
        }
      })
    },

    async CriarPasta() {
      if (!this.pastaAws.folder_name || !this.pastaAws.folder_name.trim()) return

      // Gera hash simples a partir do nome (sem dependencia de crypto)
      let h = 0
      const str = this.pastaAws.folder_name.toString() + Date.now()
      for (let i = 0; i < str.length; i++) {
        h = ((h << 5) - h + str.charCodeAt(i)) | 0
      }
      const hash = Math.abs(h).toString(36) + Math.random().toString(36).slice(2)
      const NameFoldeHash = hash.substring(0, 30)

      if (this.folderATUAL === 0) {
        this.caminhoPasta = `${this.userData.user_file_key}UploadFolderVideos/`
      } else {
        this.caminhoPasta = this.folderATUAL.folder_key_name
      }

      // Define key_name padrão (usado mesmo se S3 não estiver configurado)
      this.Url_pasta = ''
      this.key_name = `${this.caminhoPasta}${NameFoldeHash}/`

      // Tenta criar pasta no S3 (opcional — falha silenciosamente)
      try {
        const bucketApi = process.env.VUE_APP_HOST_BUCKET_CHAT || '/api/dkbucket'
        const s3Res = await fetch(
          `${bucketApi}/create?caminho=${this.caminhoPasta}${NameFoldeHash}/`,
          { method: 'POST' },
        )
        if (s3Res.ok) {
          const contentType = s3Res.headers.get('content-type') || ''
          if (contentType.includes('application/json')) {
            const s3Data = await s3Res.json()
            this.Url_pasta = s3Data.fileUrl || ''
            this.key_name = s3Data.file_key || this.key_name
          }
        }
      } catch (_s3Err) {
        // S3 não configurado — continua sem URL de bucket
      }

      // Sempre salva no banco de dados, independente do S3
      this.handleSubmit()
    },

    async cancelMoverFolder() {
      this.outerVisible = false
      this.paths = []
      this.loading = true
      this.$store.commit('Folders/setIdMainParams', 0)
      await this.$store.dispatch('Folders/getAllFolderUser')
        .finally(() => {
          this.loading = false
        })
    },
    async backToFolder(item) {
      if (item.id === 0) {
        localStorage.setItem('folderATUAL', JSON.stringify(item.id))
      } else {
        localStorage.setItem('folderATUAL', JSON.stringify(item))
      }
      this.loading = true
      const indexItem = this.paths.indexOf(item)
      this.$emit('updateVideos', item)
      this.paths.forEach((p, i) => {
        if (i > indexItem) {
          this.paths.splice(i, 1)
        }
      })
      if (item.id || item.id === 0) {
        // this.clearFolder()
      }

      this.getFoldersAll(item.id)
    },
    clearFolder() {
      this.$store.commit('Folders/setfolderAtual', {
        id: 0,
        folder_name: null,
        folder_backet_adress: null,
        id_main: null,
        id_user: null,
        folder_date: null,
        folder_key_name: null,
      })
    },
    aparecerEdição(item) {
      const strong = document.getElementById(`strong${item}`)
      const input = document.getElementById(`input${item}`)
      const botaosalvar = document.getElementById(`botao-salvar${item}`)
      const iconeeditar = document.getElementById(`icone-editar${item}`)
      strong.setAttribute('hidden', '')
      iconeeditar.setAttribute('hidden', '')
      botaosalvar.removeAttribute('hidden')
      input.removeAttribute('hidden')
    },
    salvarEdicão(item) {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: `{"folder_name":"${item.folder_name}"}`,
      }

      fetch(`${process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend'}/updateNameFolder/${item.id}`, options)
        .then(response => response.json())
        .then(response => {
          const strong = document.getElementById(`strong${item.id}`)
          const input = document.getElementById(`input${item.id}`)
          const botaosalvar = document.getElementById(`botao-salvar${item.id}`)
          const iconeeditar = document.getElementById(`icone-editar${item.id}`)
          input.setAttribute('hidden', '')
          botaosalvar.setAttribute('hidden', '')
          iconeeditar.removeAttribute('hidden')
          strong.removeAttribute('hidden')
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
  },
}
</script>
<style lang="scss" scoped>
// ── Paleta DK ──────────────────────────────────────
$dk-navy:   #0D3349;
$dk-orange: #E86A10;
$dk-gold:   #F5B935;
$dk-cream:  #EDE8C4;
$dk-border: #e8edf2;
$dk-muted:  #8a99ab;

// ── Root ───────────────────────────────────────────
.dk-folders-root {
  padding: 0 0 12px;
}

// ── Breadcrumb ─────────────────────────────────────
.dk-breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  padding: 0 0 14px;
  font-size: 0.82rem;
}

// Container-pill ao redor de todo o breadcrumb
.dk-breadcrumb::before {
  display: none; // reservado para pseudo se necessário
}

.dk-breadcrumb__item {
  display: flex;
  align-items: center;
  gap: 0;
}

.dk-breadcrumb__sep {
  display: inline-flex;
  align-items: center;
  padding: 0 4px;
  color: rgba($dk-navy, 0.25);
  font-size: 0.75rem;
  user-select: none;

  // Usar seta em vez de barra
  &::before {
    content: '›';
    font-size: 1rem;
    line-height: 1;
    color: rgba($dk-orange, 0.45);
  }
}

.dk-breadcrumb__link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  color: $dk-muted;
  font-weight: 500;
  font-size: 0.8rem;
  text-decoration: none !important;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;

  &:hover {
    background: rgba($dk-orange, 0.08);
    color: $dk-orange;
  }

  // Último item do breadcrumb = pasta atual (mais destacado)
  &--active {
    color: $dk-navy;
    font-weight: 600;
    background: rgba($dk-orange, 0.07);
    border: 1px solid rgba($dk-orange, 0.15);
  }
}

.dk-breadcrumb__icon {
  color: $dk-orange;
  flex-shrink: 0;
}

// ── Header row ─────────────────────────────────────
.dk-folders-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border, $dk-border);
  border-left: 3px solid rgba($dk-orange, 0.35);
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: var(--dk-shadow-sm, 0 2px 8px rgba($dk-navy, 0.06));
}
.dk-folders-header__left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dk-folders-header__icon {
  color: $dk-orange;
}
.dk-folders-header__title {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--dk-text-primary, $dk-navy);
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.dk-folders-header__count {
  background: rgba($dk-orange, 0.1);
  color: $dk-orange;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 20px;
  padding: 2px 9px;
  border: 1px solid rgba($dk-orange, 0.22);
}
.dk-new-folder-btn {
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  padding: 6px 14px !important;
  display: flex;
  align-items: center;
  gap: 6px;
}

// ── Folder grid ────────────────────────────────────
.dk-folder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 12px;
}

// ── Folder card ────────────────────────────────────
.dk-folder-card {
  display: flex;
  flex-direction: column;
  padding: 14px;
  background: var(--dk-bg-card, #fff);
  border: 1px solid var(--dk-border, $dk-border);
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--dk-shadow-sm, 0 1px 4px rgba($dk-navy, 0.05));
  position: relative;
  min-height: 126px;

  &:hover {
    border-color: rgba($dk-orange, 0.35);
    box-shadow: 0 8px 28px rgba($dk-orange, 0.1), var(--dk-shadow-md);
    transform: translateY(-2px);

    .dk-folder-card__icon {
      background: linear-gradient(135deg, rgba($dk-orange, 0.2) 0%, rgba($dk-gold, 0.15) 100%);
      box-shadow: 0 4px 16px rgba($dk-orange, 0.2);
    }
    .dk-folder-card__edit-btn { opacity: 1; }
    .dk-folder-card__more-btn { opacity: 1; }
  }
}

// ── Card top row (icon + actions) ──────────────────
.dk-folder-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;
}

// ── Folder icon container ──────────────────────────
.dk-folder-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba($dk-orange, 0.1) 0%, rgba($dk-gold, 0.07) 100%);
  border: 1px solid rgba($dk-orange, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

// ── Card actions ──────────────────────────────────
.dk-folder-card__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.dk-folder-card__edit-btn {
  color: var(--dk-text-faint, #b0bac4);
  cursor: pointer;
  display: flex;
  align-items: center;
  opacity: 1;
  transition: opacity 0.15s, color 0.15s;
  padding: 4px;
  border-radius: 6px;
  &:hover { color: $dk-orange; background: rgba($dk-orange, 0.08); }
}
.dk-folder-card__save-btn {
  color: #22c55e;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
}
.dk-folder-card__more-btn {
  background: none;
  border: none;
  padding: 4px;
  border-radius: 6px;
  color: var(--dk-text-faint, #c0cad4);
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.15s;
  opacity: 1;
  &:hover {
    background: rgba($dk-orange, 0.08);
    color: $dk-orange;
    opacity: 1;
  }
}

// ── Folder body ────────────────────────────────────
.dk-folder-card__body {
  min-width: 0;
}
.dk-folder-card__name {
  display: block;
  font-size: 0.84rem;
  font-weight: 600;
  color: var(--dk-text-primary, $dk-navy);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}
.dk-folder-card__name-input {
  width: 100%;
  border: 1px solid rgba($dk-orange, 0.4) !important;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.85rem;
  color: var(--dk-text-primary, $dk-navy);
  background: var(--dk-bg-input, #fff);
  outline: none;
  margin-bottom: 4px;
  &:focus {
    border-color: $dk-orange !important;
    box-shadow: 0 0 0 2px rgba($dk-orange, 0.15);
  }
}
.dk-folder-card__date {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  color: var(--dk-text-muted, $dk-muted);
}

// ── Dropdown item ──────────────────────────────────
.dk-dropdown-item {
  display: flex;
  align-items: center;
  font-size: 0.84rem;
  &--danger { color: #c12b2b; }
}

// ── Empty state ────────────────────────────────────
.dk-folders-empty {
  grid-column: 1 / -1;
  text-align: center;
  padding: 56px 24px;
  background: var(--dk-bg-card, #fff);
  border: 1px dashed rgba($dk-orange, 0.25);
  border-radius: 14px;
}
.dk-folders-empty__icon {
  color: rgba($dk-orange, 0.25);
  display: block;
  margin: 0 auto 14px;
}
.dk-folders-empty__text {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--dk-text-muted, #8e9baa);
  margin: 0 0 4px;
}
.dk-folders-empty__sub {
  font-size: 0.78rem;
  color: var(--dk-text-faint, #b0bac4);
  margin: 0;
}

// ── Responsive ────────────────────────────────────
@media (max-width: 600px) {
  .dk-folder-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .dk-folder-card { padding: 14px; }
  .dk-folder-card__icon { width: 40px; height: 40px; }
}
</style>
